import axios from 'axios'
import { Message } from 'element-ui'
import state from  '../store/index'
import { setApiUrl } from '../utils/index'
import router from '../router/index'
import qs from 'qs'

axios.defaults.baseURL = setApiUrl();
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
  let isCode = config.url.indexOf('auth/code_login') >-1

  let payload =  JSON.parse(localStorage.getItem('token'))
  let code = localStorage.getItem('code')
  if(payload && !isCode && !code){
    config.headers['token'] = payload.token
  }
  
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});


export const get = (url, params) =>{
  params = dealToken(params)
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      params: params,
    }).then(res => {
      dealData(res, resolve,url, params, 'get')
    }).catch(res=>{
      reject(res)
    })
  })
}

export const post = (url, params) => {
  params = dealToken(params)
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then(res => {
      dealData(res, resolve,url, params, 'post')
    }).catch(res=>{
      reject(res)
    })
  })
}
// 涉及到修改的接口 id在地址上
export const postChange = (url, params, method) => {
  params = dealToken(params)
  if (params.id){
    delete params.id
  }
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url:url,
      data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
    }).then(res => {
      dealData(res, resolve,url, params, method)
    }).catch(res=>{
      reject(res)
    })
  })
}

let isRefresh = false

const dealData = function(res ,resolve,url, params, method){
  let data = res.data
  if(data.state ==1){
    resolve(data.data)
  }else  if(data.state == 0){
    if(!data.message||data.message === '错误'){
      let dataMsg = data.data;
      let firstMsg = dataMsg[Object.keys(dataMsg)[0]]
      Message({message:firstMsg,type:'error'}) //一次只提醒一条报错信息
      resolve(res)
    }else if (data.status == 105 || data.status == 101 || data.status === 203 || data.status === 111){
      // 105 刷新后的token也过期      // 101 当前token和数据库存的token不一致
      Message({message:data.message,type:'error'})
      router.push({path: '/expired'})
    }else {
      Message({message:data.message,type:'error'})
    }
  }
}
// 刷新token接口
const refreshToken = function (url, params, method){
  let payload =  JSON.parse(localStorage.getItem('token'))
  post('api/auth/refresh', {
    refresh_token: payload.prv+"_"+payload.jti,
    token: payload.token
  }).then(res=>{
    isRefresh = false
    console.log(res,'klkl')
    if(res.payload){
      state.commit('SET_TOKEN',res.payload)
      window.location.reload()
    }   
  }).catch(res=>{
    console.log(res,'catch')
  })
}

const dealToken = function(params){
  return params
}
